// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4WqkC","title":"styles_title__ijVmR","wrapper":"styles_wrapper__h3szG"};